import styled from "styled-components";

export const UserHintStyled = styled.div`
    padding: 8px 12px;
    background: var(--color-button-primary-default);
    color: var(--color-label-primary-inverted);
    font-size: 14px;
`;

export const UserHintWrapperStyled = styled.div`
    display: flex;
    gap: 10px;
    opacity: 0;

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    &.isInitialized {
        animation: fadeIn 0.5s;
        opacity: 1;
    }
    
    &.avatar-top {
        align-items: flex-start;
        ${UserHintStyled} {
            border-radius: 16px 4px 16px 16px;
        }
    }
    
    &.avatar-bottom {
        align-items: flex-end;
        ${UserHintStyled} {
            border-radius: 16px 16px 4px 16px;
        }
    }
`;

export const UserHintButtonStyled = styled.div`
    margin-top: 12px;
    padding: 4px 12px;
    color: var(--color-label-primary);
    border-radius: 12px;
    width: fit-content;
    background: var(--color-label-primary-inverted);
    cursor: pointer;
`;

export const UserHintAvatarStyled = styled.div<{ url: string }>`
    width: 64px;
    height: 64px;
    flex-shrink: 0;
    border-radius: 100%;
    overflow: hidden;
    background: ${props => `url(${props.url}) no-repeat center / cover`};
`;